// NGXS actions must stay newable classes: withActions/createDispatchMap in
// @res/ngg-core is typed over ActionDef, which requires a `new (...args)`
// signature, and the dispatcher matches action results by reference identity.
// The parameterless ones therefore carry a mirror instance field so they are
// not classes of statics only. NGXS resolves the type from constructor.type
// first, so the dispatched string is unchanged.
import { DateRangeType } from '@res/ng-data-access';
import { AdvancedFilterModel, FilterModel, IServerSideGetRowsRequest } from 'ag-grid-community';
import { VehicleRef, VehicleUpdateData } from '../../schema/schema.interface';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace VehicleActions {
  export class GetAllVehicle {
    static readonly type = '[Vehicle] GetAllVehicle';
    readonly type = GetAllVehicle.type;
  }

  export class InitVehiclesCount {
    static readonly type = '[Vehicle] InitVehicleCount';
    readonly type = InitVehiclesCount.type;
  }

  export class InitVehicles {
    static readonly type = '[Vehicle] InitVehicles';
    readonly type = InitVehicles.type;
  }
  export class CountVehicles {
    static readonly type = '[Vehicle] CountVehicles';
    readonly type = CountVehicles.type;
  }

  export class CloseVehiclesConnection {
    static readonly type = '[Vehicle] CloseVehiclesConnection';
    readonly type = CloseVehiclesConnection.type;
  }

  export class GetVehicleById {
    static readonly type = '[Vehicle] GetVehicleById';
    readonly type = GetVehicleById.type;
  }

  export class UpdateVehicle {
    static readonly type = '[Vehicle] UpdateVehicle';
    constructor(
      public vehicleData: Partial<VehicleUpdateData>,
      public ref: VehicleRef,
    ) {}
  }

  export class DeleteVehicles {
    static readonly type = '[Vehicle] DeleteVehicles';
    constructor(public refs: VehicleRef[]) {}
  }

  export class PaginateQueryVehicle {
    static readonly type = '[Vehicle] PaginateQueryVehicle';
    constructor(
      public request: IServerSideGetRowsRequest,
      public isResetAfterFilterOrSort = false,
      public userId?: string,
    ) {}
  }
  export class VehicleError {
    static readonly type = '[Vehicle] VehicleError';
    constructor(public error: Error) {}
  }

  export class GetSumOf {
    static readonly type = '[Vehicle] GetSumOf';
    constructor(
      public field: string,
      public timePeriod: DateRangeType,
    ) {}
  }
  export class GetSumsCountOf {
    static readonly type = '[Vehicle] GetSumsCountOf';
    constructor(
      public fields: {
        sumId: string;
        countId: string;
        countValue: number | string | boolean | Date;
      }[],
      public timePeriod: DateRangeType,
      public filterModel?: FilterModel | AdvancedFilterModel | null,
      public userId?: string,
    ) {}
  }
}
